<script>
  export let resumo = "Ganhe até 20% de comissão por indicações no FitPace!";
</script>

<style>
  .afiliados-container {
    background-color: #f1f1f1;
    padding: 30px;
    text-align: center;
  }

  .afiliados-titulo {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .afiliados-descricao {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .afiliados-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
  }
</style>

<div class="afiliados-container">
  <div class="afiliados-titulo">Programa de Afiliados</div>
  <div class="afiliados-descricao">{resumo}</div>
  <button class="afiliados-button">Saiba Mais</button>
</div>
